<template>
  <div class="gp-comment" :class="comment.removedAt ? 'gp-comment--removed' : ''">
    <div class="gp-comment__title">
      <span class="-text--weight-bold">{{ comment.username }}</span>
      <small class="-flex--grow">
        {{ $d(comment.createdAt, 'compact') }}
        <template v-if="comment.updatedAt.valueOf() !== comment.createdAt.valueOf()">
          &mdash;
          <strong>{{ $t('activerecord.attributes.comment.updated_at') }}</strong>
          {{ $d(comment.updatedAt, 'compact') }}
        </template>
      </small>
      <div v-if="!comment.removedAt && (isOwner || isMapOwner)" class="-flex-none">
        <rui-toolbar>
          <rui-button v-if="isOwner"
                      icon="pencil"
                      :title="$t('generic.edit')"
                      size="small"
                      @click="handleEditComment" />
          <rui-button v-if="isMapOwner || isOwner"
                      icon="trash"
                      :title="$t('generic.destroy')"
                      variant="destructive"
                      size="small"
                      @click="handleDestroyComment" />
        </rui-toolbar>
      </div>
    </div>

    <div class="gp-comment__content _writing">{{ comment.content }}</div>

    <gp-comment-form v-if="showEditionForm"
                     class="-ps"
                     :comment="comment"
                     @saved="handleUpdatedComment"
                     @cancel="showEditionForm = false" />
  </div>
</template>

<script>
import RuiButton from '@experiments-labs/rise_ui/src/components/Button/Button.vue'
import RuiToolbar from '@experiments-labs/rise_ui/src/components/Toolbar/Toolbar.vue'

import Comment from '../../../classes/models/Comment'

import Toaster from '../../../tools/Toaster'

import GpCommentForm from './Form.vue'

/**
 * Displays a `Comment`
 *
 * @noPlayground
 */
export default {
  name: 'GpCommentEntry',
  emits: ['updated', 'destroyed'],
  components: { GpCommentForm, RuiButton, RuiToolbar },
  props: {
    /** `Comment` to display */
    comment: { required: true, type: Comment },
  },
  data () {
    return {
      showEditionForm: false,
    }
  },
  computed: {
    signedIn () { return this.$store.getters.signedIn },
    currentUser () { return this.$store.getters.account },
    isOwner () { return this.signedIn && this.currentUser.id === this.$props.comment.userId },
    isMapOwner () { return this.signedIn && this.$store.getters.isMapOwner },
  },
  methods: {
    handleUpdatedComment (comment) {
      this.showEditionForm = false
      this.$emit('updated', comment)
    },
    handleEditComment () { this.showEditionForm = true },
    handleDestroyComment () {
      this.$emitBus('ask-confirmation', {
        caption: this.$t('js.comment.destroy_warning_title'),
        message: !this.isOwner && this.isMapOwner ? this.$t('js.comment.destroy_warning_admin') : this.$t('js.comment.destroy_warning'),
        callback: () => {
          Comment.remove(this.comment.id)
            .then((comment) => {
              this.$emit('destroyed', comment)
              Toaster.success(this.$t('js.comment.successfully_destroyed'))
            })
            .catch(() => {
              Toaster.error(this.$t('js.comment.failed_to_destroy'))
            })
        },
      })
    },
  },
}
</script>
